(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["river-display-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('river-display-carousel')) {
    class RiverDisplayCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.river-display__track');
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.modeButtons = [...this.querySelectorAll('[data-mode-option]')];
        this.toggle = this.querySelector('.river-display__toggle');
        if (this.toggle && this.querySelector('[data-dark-image]')) {
          this.toggle.hidden = false;
          if (this.dataset.defaultMode === 'dark') this.setMode('dark');
        }
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.dot))));
        this.modeButtons.forEach((button) =>
          button.addEventListener('click', () => this.setMode(button.dataset.modeOption))
        );
        this.onScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateDots());
        };
        this.track?.addEventListener('scroll', this.onScroll, { passive: true });
        // Trackpad/mouse-wheel over the slides is handled here. Left to the browser, the whole gesture can
        // latch onto the sideways track (a trackpad swipe always has a little sideways movement) and the
        // snap undoes it, so the page looked stuck. Mostly vertical: scroll the page. Mostly sideways:
        // one slide per swipe (the momentum tail of the same swipe is ignored).
        this.onWheel = (event) => {
          if (event.ctrlKey) return;
          const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? this.track.clientWidth : 1;
          event.preventDefault();
          clearTimeout(this.wheelTimer);
          this.wheelTimer = setTimeout(() => {
            this.wheelX = 0;
            this.wheelLocked = false;
          }, 200);
          if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
            this.pageScroller()?.scrollBy({ top: event.deltaY * unit, behavior: 'instant' });
            return;
          }
          if (this.wheelLocked) return;
          this.wheelX = (this.wheelX || 0) + event.deltaX * unit;
          if (Math.abs(this.wheelX) < 30) return;
          this.wheelLocked = true;
          this.goTo(this.current() + Math.sign(this.wheelX));
        };
        this.track?.addEventListener('wheel', this.onWheel, { passive: false });
        this.track?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') this.goTo(this.current() + 1);
          if (event.key === 'ArrowLeft') this.goTo(this.current() - 1);
        });
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('wheel', this.onWheel);
      }

      // The element the page scrolls in (the theme can scroll a wrapper instead of the document)
      pageScroller() {
        for (let node = this.parentElement; node && node !== document.body; node = node.parentElement) {
          const overflowY = getComputedStyle(node).overflowY;
          if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
        }
        return document.scrollingElement;
      }

      slides() {
        return [...this.querySelectorAll('[data-slide]')];
      }

      current() {
        const slides = this.slides();
        if (!this.track || !slides.length) return 0;
        const left = this.track.scrollLeft;
        let index = 0;
        slides.forEach((slide, i) => {
          if (Math.abs(slide.offsetLeft - slides[0].offsetLeft - left) < Math.abs(slides[index].offsetLeft - slides[0].offsetLeft - left)) index = i;
        });
        // At the end of the track the last slide can't reach the start edge
        if (left + this.track.clientWidth >= this.track.scrollWidth - 2) index = slides.length - 1;
        return index;
      }

      goTo(index) {
        const slides = this.slides();
        const target = slides[Math.max(0, Math.min(index, slides.length - 1))];
        if (!target) return;
        this.track.scrollTo({
          left: target.offsetLeft - slides[0].offsetLeft,
          behavior: this.reduceMotion ? 'auto' : 'smooth',
        });
      }

      updateDots() {
        const index = this.current();
        this.dots.forEach((dot, i) => {
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      setMode(mode) {
        if (mode === 'dark') {
          // First switch: move each dark image out of its template so it starts loading now
          this.querySelectorAll('template[data-dark-image]').forEach((template) => {
            template.replaceWith(template.content.cloneNode(true));
          });
        }
        this.dataset.mode = mode;
        this.modeButtons.forEach((button) =>
          button.setAttribute('aria-pressed', String(button.dataset.modeOption === mode))
        );
      }
    }

    customElements.define('river-display-carousel', RiverDisplayCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["river-hero"] && !Shopify.designMode) return;
  try {
    
  // Mobile phone row scrolls sideways: make it reachable by keyboard (arrow keys scroll it) and give it a name
  document.querySelectorAll('.river-hero--phone-row[data-phone-label]').forEach((hero) => {
    const row = hero.querySelector('.layout-panel-flex--row:has(> .group-block > .group-block-content > .image-block)');
    if (!row) return;
    const update = () => {
      if (row.scrollWidth > row.clientWidth + 1) {
        row.setAttribute('tabindex', '0');
        row.setAttribute('role', 'region');
        row.setAttribute('aria-label', hero.dataset.phoneLabel);
      } else {
        ['tabindex', 'role', 'aria-label'].forEach((name) => row.removeAttribute(name));
      }
    };
    update();
    window.addEventListener('resize', update, { passive: true });
  });

  // Mobile phone row: rotate the cards until the visitor touches the row, then leave it to them
  document.querySelectorAll('.river-hero--phone-row[data-phone-autoplay]').forEach((hero) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const row = hero.querySelector('.layout-panel-flex--row:has(> .group-block > .group-block-content > .image-block)');
    if (!row) return;
    const delay = Number(hero.dataset.phoneAutoplay) || 3000;
    let timer = null;
    let visible = false;
    let stopped = false;

    const scrollable = () => row.scrollWidth > row.clientWidth + 1;
    const advance = () => {
      if (!scrollable()) return;
      const count = row.children.length;
      const next = (Math.round(row.scrollLeft / row.clientWidth) + 1) % count;
      row.scrollTo({ left: next * row.clientWidth, behavior: 'smooth' });
    };
    const start = () => {
      if (!stopped && visible && !timer) timer = setInterval(advance, delay);
    };
    const pause = () => {
      clearInterval(timer);
      timer = null;
    };
    const stop = () => {
      stopped = true;
      pause();
    };

    ['pointerdown', 'touchstart', 'wheel', 'keydown', 'focusin'].forEach((type) =>
      row.addEventListener(type, stop, { passive: true, once: true })
    );
    new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      if (visible) start();
      else pause();
    }, { threshold: 0.5 }).observe(row);
  });

  // Glass video: attach its sources once the page has loaded, and only where the glass is shown (not on
  // mobile unless enabled, never for reduced motion). Until then the poster holds the first frame.
  const loadGlassVideos = () => {
    document.querySelectorAll('video.river-hero__glass-video[data-river-deferred]').forEach((video) => {
      if (getComputedStyle(video.parentElement).display === 'none') return;
      video.removeAttribute('data-river-deferred');
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
      video.load();
      video.play().catch(() => {});
    });
  };
  const whenIdle = (fn) => ('requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 2000 }) : setTimeout(fn, 200));
  if (document.readyState === 'complete') whenIdle(loadGlassVideos);
  else window.addEventListener('load', () => whenIdle(loadGlassVideos), { once: true });

  document.querySelectorAll('video.river-hero__glass-video').forEach((video) => {
    // Playback speed from the section setting (browsers reset it on load, so set it again then)
    const speed = Number(video.parentElement?.dataset.speed) || 1;
    const setSpeed = () => {
      video.defaultPlaybackRate = speed;
      video.playbackRate = speed;
    };
    setSpeed();
    video.addEventListener('loadedmetadata', setSpeed);
    const show = () => video.classList.add('is-playing');
    if (!video.paused && video.readyState > 2) show();
    else video.addEventListener('playing', show, { once: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["river-pdp-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('river-tabs')) {
    class RiverTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => {
            const keys = { ArrowRight: 1, ArrowLeft: -1 };
            if (event.key in keys) {
              event.preventDefault();
              const next = (index + keys[event.key] + this.tabs.length) % this.tabs.length;
              this.select(next);
              this.tabs[next].focus();
            }
          });
        });
      }

      select(index) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      }
    }

    customElements.define('river-tabs', RiverTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["river-savings-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('river-savings-calculator')) {
    class RiverSavingsCalculator extends HTMLElement {
      connectedCallback() {
        const local = this.localMoney();
        if (local) this.localiseAssumptions(parseFloat(this.dataset.cost), { format: (n) => local.format(n * local.rate, true) });
        this.steps = [...this.querySelectorAll('[data-step]')];
        this.progress = this.querySelector('[data-progress]');
        this.current = 0;

        this.querySelectorAll('.river-calc__range').forEach((input) => {
          const chip = input.closest('[data-step]').querySelector('[data-chip]');
          const update = () => {
            chip.textContent = input.value;
            const pct = ((input.value - input.min) / (input.max - input.min)) * 100;
            input.style.setProperty('--fill', `${pct}%`);
          };
          input.addEventListener('input', update);
          update();
        });

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-next]')) {
            if (this.current === 2) this.calculate();
            this.show(this.current + 1);
          } else if (event.target.closest('[data-back]')) {
            this.show(this.current - 1);
          }
        });

        this.querySelector('.river-calc__form')?.addEventListener('submit', (event) => this.submit(event));

        // Back from Shopify's verification check (normal submit): restore the answers, show the results,
        // the thank-you and the optional phone step. The lead event fires from snippets/river-lead-event.
        if (/[?&]customer_posted=true/.test(location.search) && location.hash === '#RiverCalcForm') this.restoreAfterSignup();
      }

      restoreAfterSignup() {
        let state = null;
        let email = null;
        try {
          state = JSON.parse(sessionStorage.getItem('river_calc_state') || 'null');
          email = sessionStorage.getItem('river_signup_email');
          sessionStorage.removeItem('river_calc_state');
        } catch (e) {}
        if (Array.isArray(state)) {
          state.forEach((v, i) => {
            const input = this.querySelector(`[data-input="${i + 1}"]`);
            if (!input) return;
            input.value = v;
            input.dispatchEvent(new Event('input'));
          });
        }
        this.calculate();
        this.show(this.steps.length - 1);
        const form = this.querySelector('#RiverCalcForm');
        this.querySelector('[data-ok]').hidden = false;
        const sms = this.querySelector('river-sms-step');
        if (sms && email) {
          form.hidden = true;
          customElements.whenDefined('river-sms-step').then(() => sms.start(email));
        }
        this.scrollIntoView({ block: 'center' });
      }

      show(index) {
        if (index < 0 || index >= this.steps.length) return;
        this.steps[this.current].hidden = true;
        this.current = index;
        this.steps[index].hidden = false;
        this.updateProgress();
        this.steps[index].querySelector('[data-step-heading]')?.focus({ preventScroll: true });
      }

      updateProgress() {
        if (!this.progress) return;
        const total = this.steps.length;
        const percent = Math.round((this.current / (total - 1)) * 100);
        this.progress.style.setProperty('--p', percent);
        this.progress.setAttribute('aria-valuenow', percent);
        this.progress.setAttribute('aria-valuetext', `${this.current + 1} / ${total}`);
        this.progress.querySelectorAll('[data-tick]').forEach((tick) => {
          tick.classList.toggle('is-reached', Number(tick.dataset.tick) <= this.current);
        });
        const step = this.querySelector('[data-progress-step]');
        const pct = this.querySelector('[data-progress-percent]');
        step.textContent = step.dataset.template.replace('[current]', this.current + 1).replace('[total]', total);
        pct.textContent = pct.dataset.template.replace('[percent]', percent);
      }

      value(n) {
        return Number(this.querySelector(`[data-input="${n}"]`).value);
      }

      // Costs are entered in the shop currency (USD). For a visitor in another market they are converted
      // with Shopify's rate and shown in the store's money format for that currency, like the rest of the page.
      localMoney() {
        const d = this.dataset;
        const rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
        if ((d.currency || 'USD') !== d.shopCurrency || d.visitorCurrency === d.shopCurrency || !rate) return null;

        // "£123,456.00" / "123.456,00 €" / "$123.456" -> prefix, thousands, decimals, suffix
        const f = d.moneyFormat || '';
        const m = f.match(/123(\D?)456(?:(\D)00)?/);
        if (!m) return null;
        const prefix = f.slice(0, m.index);
        const suffix = f.slice(m.index + m[0].length);
        return {
          rate,
          format(n, cents) {
            // Cents only for small amounts (£0.07), not for currencies like COP where a minute costs $290
            const decimals = cents && m[2] && Math.abs(n) < 10 ? 2 : 0;
            const [whole, frac] = Math.abs(n).toFixed(decimals).split('.');
            const amount = whole.replace(/\B(?=(\d{3})+(?!\d))/g, m[1]) + (frac ? m[2] + frac : '');
            return (n < 0 ? '-' : '') + prefix + amount + suffix;
          },
        };
      }

      // The assumptions note quotes the cost per minute in USD ("$0.09"): show it in the visitor's currency
      localiseAssumptions(cost, cf2) {
        if (this.assumptionsLocalised) return;
        this.assumptionsLocalised = true;
        const usd = '$' + this.dataset.cost;
        this.querySelectorAll('.river-calc__disclaimer p').forEach((p) => {
          p.childNodes.forEach((node) => {
            if (node.nodeType === Node.TEXT_NODE && node.nodeValue.includes(usd)) {
              node.nodeValue = node.nodeValue.split(usd).join(cf2.format(cost));
            }
          });
        });
      }

      calculate() {
        const d = this.dataset;
        const gpm = parseFloat(d.gpm);
        const lpm = parseFloat(d.lpm);
        const cost = parseFloat(d.cost);
        const rate = Number(d.rate) / 100;
        const locale = d.locale || 'en-US';
        const nf0 = new Intl.NumberFormat(locale);
        const nf1 = new Intl.NumberFormat(locale, { maximumFractionDigits: 1 });
        let cf0 = new Intl.NumberFormat(locale, { style: 'currency', currency: d.currency || 'USD', maximumFractionDigits: 0 });
        let cf2 = new Intl.NumberFormat(locale, { style: 'currency', currency: d.currency || 'USD', maximumFractionDigits: 2 });
        const local = this.localMoney();
        if (local) {
          cf0 = { format: (n) => local.format(n * local.rate, false) };
          cf2 = { format: (n) => local.format(n * local.rate, true) };
          this.localiseAssumptions(cost, cf2);
        }

        // Same maths as the live calculator
        const minutesYear = this.value(1) * this.value(3) * 52 * this.value(2);
        const gallonsYear = minutesYear * gpm;
        // Exact conversion from gallons (1 US gal = 3.785411784 L); the rounded L/min setting is only for display
        const litersYear = gallonsYear * 3.785411784;
        const costYear = minutesYear * cost;

        const tokens = [
          { gallons: nf0.format(Math.round(gallonsYear)), liters: nf0.format(Math.round(litersYear)) },
          { hours: nf1.format(minutesYear / 60), minutes: nf0.format(Math.round(minutesYear)) },
          { cost: cf0.format(Math.round(costYear)), cost_per_min: cf2.format(cost), gpm: String(gpm), lpm: String(lpm) },
          {
            cost: cf0.format(Math.round(costYear * rate)),
            gallons: nf0.format(Math.round(gallonsYear * rate)),
            liters: nf0.format(Math.round(litersYear * rate)),
            hours: nf1.format((minutesYear * rate) / 60),
          },
        ];

        tokens.forEach((values, i) => {
          const fill = (el) => {
            el.textContent = el.dataset.template.replace(/\[(\w+)\]/g, (match, key) => values[key] ?? match);
          };
          fill(this.querySelector(`[data-kpi-value="${i + 1}"]`));
          fill(this.querySelector(`[data-kpi-note="${i + 1}"]`));
        });
      }

      submit(event) {
        // Shopify's spam protection (hCaptcha) adds its token during a normal form submit, so the form submits
        // normally (no background request) and Shopify reloads with ?customer_posted=true#<form id>. The success
        // view, phone step and lead event run from there (snippets/river-lead-event, river-sms-step).
        const input = this.querySelector('[data-email]');
        this.querySelector('[data-ok]').hidden = true;
        this.querySelector('[data-error]').hidden = true;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim())) {
          event.preventDefault();
          input.setAttribute('aria-invalid', 'true');
          input.focus();
          return;
        }
        input.removeAttribute('aria-invalid');
        // Keep the answers so the results can be shown again after the reload
        try {
          sessionStorage.setItem('river_calc_state', JSON.stringify([1, 2, 3].map((n) => this.value(n))));
        } catch (e) {}
      }
    }

    customElements.define('river-savings-calculator', RiverSavingsCalculator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["river-waitlist-modal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('river-waitlist-modal')) {
    class RiverWaitlistModal extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.anchor = `#${this.dataset.anchor}`;

        this.onDocClick = (event) => {
          const link = event.target.closest(`a[href$="${this.anchor}"]`);
          if (!link) return;
          event.preventDefault();
          this.open();
        };
        document.addEventListener('click', this.onDocClick);

        this.querySelectorAll('[data-close]').forEach((button) => button.addEventListener('click', () => this.dialog.close()));
        // Click on the backdrop closes
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.form.addEventListener('submit', (event) => this.submit(event));

        if (location.hash === this.anchor) this.open();
        // Returning from Shopify's spam check (normal submit) lands on ?customer_posted=true#RiverWaitlistForm
        if (/[?&]customer_posted=true/.test(location.search) && location.hash === '#RiverWaitlistForm') {
          let email = null;
          try {
            email = sessionStorage.getItem('river_signup_email');
          } catch (e) {}
          this.afterSignup(email);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocClick);
      }

      // Optional phone step first (if turned on), then the success view. The email is already saved.
      async afterSignup(email) {
        const sms = this.querySelector('river-sms-step');
        if (sms && email) {
          this.show('sms');
          if (!this.dialog.open) this.dialog.showModal();
          await customElements.whenDefined('river-sms-step');
          await sms.start(email);
        }
        this.open(true);
      }

      open(success = false) {
        this.show(success ? 'success' : 'form');
        if (!this.dialog.open) this.dialog.showModal();
        if (success) this.querySelector('[data-success-title]').focus();
      }

      show(view) {
        this.querySelectorAll('[data-view]').forEach((el) => (el.hidden = el.dataset.view !== view));
      }

      submit(event) {
        // Shopify's spam protection (hCaptcha) adds its token during a normal form submit, so the form submits
        // normally (no background request) and Shopify reloads with ?customer_posted=true#<form id>. The success
        // view, phone step and lead event run from there (snippets/river-lead-event, river-sms-step).
        this.querySelector('[data-error]').hidden = true;
        let firstInvalid = null;
        this.form.querySelectorAll('input[required]').forEach((input) => {
          const valid = input.type === 'email' ? /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim()) : input.value.trim() !== '';
          input.toggleAttribute('aria-invalid', !valid);
          if (!valid && !firstInvalid) firstInvalid = input;
        });
        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.focus();
        }
      }
    }

    customElements.define('river-waitlist-modal', RiverWaitlistModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["river-waitlist-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('river-waitlist-signup')) {
    class RiverWaitlistSignup extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', (event) => this.submit(event));
        // Returning from Shopify's spam check (normal submit) lands on ?customer_posted=true#<form id>
        if (/[?&]customer_posted=true/.test(location.search) && location.hash === `#${this.dataset.formId}`) {
          let email = null;
          try {
            email = sessionStorage.getItem('river_signup_email');
          } catch (e) {}
          this.afterSignup(email);
        }
      }

      // Optional phone step first (if turned on), then the success message. The email is already saved.
      async afterSignup(email) {
        const sms = this.querySelector('river-sms-step');
        if (sms && email) {
          this.querySelectorAll('[data-view]').forEach((el) => (el.hidden = el.dataset.view !== 'sms'));
          await customElements.whenDefined('river-sms-step');
          await sms.start(email);
        }
        this.success();
      }

      success() {
        this.querySelectorAll('[data-view]').forEach((el) => (el.hidden = el.dataset.view !== 'success'));
        this.querySelector('[data-success-title]').focus();
      }

      submit(event) {
        // Shopify's spam protection (hCaptcha) adds its token during a normal form submit, so the form submits
        // normally (no background request) and Shopify reloads with ?customer_posted=true#<form id>. The success
        // view, phone step and lead event run from there (snippets/river-lead-event, river-sms-step).
        const input = this.form.querySelector('input[type="email"]');
        this.querySelector('[data-error]').hidden = true;
        const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
        input.toggleAttribute('aria-invalid', !valid);
        if (!valid) {
          event.preventDefault();
          input.focus();
        }
      }
    }

    customElements.define('river-waitlist-signup', RiverWaitlistSignup);
  }

  } catch(e) { console.error(e); }
})();
})();
